const rout_login = "/auth-login"

const rout_dashBoard = "/search-bar"


export {
    rout_login,
    rout_dashBoard,
}